import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryFedexForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-fedex',
  templateUrl: './fedex.component.html',
  styleUrls: ['./fedex.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FedexComponent {
  delivery = input<DeliveryFedexForm>();
}
